/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Section_DescriptionInputs */

const en_disabled_websites_section_description = /** @type {(inputs: Disabled_Websites_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These websites may have limited compatibility with our extension. Even when enabled, some features might not work correctly.`)
};

const es_disabled_websites_section_description = /** @type {(inputs: Disabled_Websites_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estos sitios pueden tener compatibilidad limitada con la extensión. Incluso habilitados, algunas funciones podrían fallar.`)
};

/**
* | output |
* | --- |
* | "These websites may have limited compatibility with our extension. Even when enabled, some features might not work correctly." |
*
* @param {Disabled_Websites_Section_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_section_description = /** @type {((inputs?: Disabled_Websites_Section_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Section_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_section_description(inputs)
	return en_disabled_websites_section_description(inputs)
});